module.exports = __webpack_public_path__ + "80227f33731824bef85d1e13827119cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/aventurometre.svg
// module id = 229
// module chunks = 0